import {
  call, put, takeLatest, select, all
} from 'redux-saga/effects';
import { authRequest } from '../../helpers/request.helper';
import { APP_GET_LOGO_REQUEST_FAILURE, APP_GET_LOGO_REQUEST_SUCCESS } from '../actions/constants/app.constants';
import {
  CORE_OBTENER_ENTIDADES_BASICAS_REQUEST,
  CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_REQUEST,
  CORE_OBTENER_ENTIDADES_BASICAS_SUCCESS,
  CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_SUCCESS,
} from '../actions/constants/core.constants';

const authState = state => state.auth;

function esUsuarioActivoDeMiTienda({ usuario, tiendaId }) {
  return usuario && usuario.inactivo !== true && usuario.tienda && usuario.tienda.id == tiendaId;
}
function* obtenerEntidadesCore() {
  const auth = yield select(authState);
  const { user: { user_info: { tienda_id: tiendaId } } } = auth;
  let usuarios = [];
  let usuariosActivosDeMiTienda = [];
  let formasPago = [];
  let motivosCompra = [];
  let motivosDevolucion = [];
  let tiendas = [];
  function* asyncInicializar() {
    try {
      const response = yield call(authRequest, { url: 'api/core/inicializar', method: 'GET' });
      usuarios = response.usuarios; // TODO: Necesario al inicio
      usuariosActivosDeMiTienda = usuarios.filter(usuario => (usuario.id !== 0 && esUsuarioActivoDeMiTienda({ usuario, tiendaId })));
      formasPago = response.formas_pago; // TODO: Separar en otro WS
      motivosCompra = response.motivos_compra; // TODO: Separar en otro WS
      motivosDevolucion = response.motivos_devolucion; // TODO: Separar en otro WS. 
      tiendas = response.tiendas; // TODO: Necesario al inicio
    } catch (ex) {
      console.error(ex);
    }
  }

  let logotipo_base64 = null;
  function* getLogo() {
    const params = {
      url: 'api/generico/logotipo',
      method: 'GET',
    };
    try {
      const result = yield call(authRequest, params)
      logotipo_base64 = result.logotipo_base64;

    } catch (error) {
    }
  }
  
  yield all([
    asyncInicializar(),
    getLogo(),
  ]); 
  if(logotipo_base64 !== null)
    yield put({ type: APP_GET_LOGO_REQUEST_SUCCESS, payload: logotipo_base64 });
  else 
    yield put({ type: APP_GET_LOGO_REQUEST_FAILURE });

  yield put({
    type: CORE_OBTENER_ENTIDADES_BASICAS_SUCCESS,
    payload: {
      usuarios, formasPago, motivosCompra, tiendas, usuariosActivosDeMiTienda, motivosDevolucion,
    },
  });
  yield put({ type: CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_REQUEST });
}
function* obtenerEntidadesCoreExtra() {
  let motivos = [];
  let tiposArticulo = [];
  let subtiposArticulo = [];
  let tiposEncargo = [];
  let bonificaciones = [];
  let promociones = [];

  function* asyncTiposarticulo() {
    try {
      const response = yield call(authRequest, { url: 'api/tiposarticulo/buscar', method: 'POST' });
      tiposArticulo = response.datos;
    } catch (ex) {
      console.error(ex);
    }
  }  
  function* asyncSubtiposArticulo() {
    try {
      const body = new FormData();
      body.append('limite', '500');
      const response = yield call(authRequest, { url: 'api/subtiposArticulo/buscar', method: 'POST', body });
      subtiposArticulo = response.datos;
    } catch (ex) {
      console.error(ex);
    }
  }
  function* asyncTiposencargo() {
    try {
      const response = yield call(authRequest, { url: 'api/tiposencargo/buscar?limit=50&consulta={"inactivo":{"valor": "false"}}', method: 'POST' });
      tiposEncargo = response.datos;
    } catch (ex) {
      console.error(ex);
    }
  }
  function* asyncMotivos() {
    try {
      const response = yield call(authRequest, { url: 'api/generico/motivos', method: 'POST' });
      motivos = response.motivos;
    } catch (ex) {
      console.error(ex);
    }
  }
  function* asyncBonificaciones() {
    try {
      const body = new FormData();
      body.append('consulta', JSON.stringify({
        inactivo: { valor: 'NO' },
      }));
      body.append('limite', 500);
      const response = yield call(authRequest, { url: 'api/bonificaciones/buscar', method: 'POST', body });
      bonificaciones = response.datos;
    } catch (ex) {
      console.error(ex);
    }
  }
  function* asyncPromociones() {
    try {
      const formData = new FormData();
      const params = {
        url: 'api/promociones/buscar',
        method: 'POST',
        body: formData,
      };
      const response = yield call(authRequest, params);
      const { datos, total } = response;
      promociones = datos;
    } catch (ex) {
      console.error(ex);
    }
  }
  yield all([
    asyncTiposarticulo(),
    asyncSubtiposArticulo(),
    asyncTiposencargo(),
    asyncMotivos(),
    asyncBonificaciones(),
    asyncPromociones()
  ]); 
  yield put({
    type: CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_SUCCESS,
    payload: {
      motivos, tiposArticulo, tiposEncargo, bonificaciones, subtiposArticulo, promociones,
    },
  });
}

function* coreSaga() {
  yield takeLatest(CORE_OBTENER_ENTIDADES_BASICAS_REQUEST, obtenerEntidadesCore);
  yield takeLatest(CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_REQUEST, obtenerEntidadesCoreExtra);
}

export default coreSaga;
